import { j as o } from "./index.es3.js";
import s from "./index.es33.js";
const e = {
  refnote: s
}, i = (r, t) => {
  if (r.attribs && r.type === "tag" && r.name && e[r.name]) {
    const a = e[r.name];
    return /* @__PURE__ */ o.jsx(a, { id: "", ...r.attribs }, t);
  }
};
export {
  i as default
};
//# sourceMappingURL=index.es8.js.map
